import React from 'react';
import { Typography, Button, Slide } from '@material-ui/core';
import FirstStep from './Navigation/FirstStep';
import SecondStep from './Navigation/SecondStep';
import ThirdStep from './Navigation/ThirdStep';
import FourthStep from './Navigation/FourthStep';
import '../css/Navigation.scss';

function Navigation(props) {
    const { values, prevStep, nextStep, handleChange } = props;
    const { naviVisible } = values;
    const next = (event) => {
        event.preventDefault();
        nextStep();
        props.valueClear();
    }
    return (
        <React.Fragment>
            <Slide direction={naviVisible.direction} in={naviVisible.start} unmountOnExit timeout={{ enter: 0, exit: 0 }}>
                <div>
                    <Typography variant="h6" component="h6" className="navi-title">
                        支承選定をナビゲーションします
                    </Typography>
                    <div className="navi-description">
                        いくつかの橋梁条件から、これまで弊社が関わった支承設計データ(2016年以降)より、採用実績のある「支承構造」をご紹介します。<br/>
                        また、支承構造ごとに採用された「弊社製品」をご案内します。
                    </div>
                    <div className="navi-paging">
                        <Button size="large" variant="contained" color="default" onClick={next}>さっそくナビを開始する</Button>
                    </div>
                </div>
            </Slide>
            <Slide direction={naviVisible.direction} in={naviVisible.first} mountOnEnter unmountOnExit timeout={{ enter: 300, exit: 0 }}>
                <div>
                    <FirstStep 
                        prevStep={prevStep}
                        nextStep={nextStep}
                        handleChange={handleChange}
                        values={values}
                    />
                </div>
            </Slide>
            <Slide direction={naviVisible.direction} in={naviVisible.second} mountOnEnter unmountOnExit timeout={{ enter: 300, exit: 0 }}>
                <div>
                    <SecondStep 
                        prevStep={prevStep}
                        nextStep={nextStep}
                        handleChange={handleChange}
                        values={values}
                    />
                </div>
            </Slide>
            <Slide direction={naviVisible.direction} in={naviVisible.third} mountOnEnter unmountOnExit timeout={{ enter: 300, exit: 0 }}>
                <div>
                    <ThirdStep 
                        prevStep={prevStep}
                        nextStep={nextStep}
                        handleChange={handleChange}
                        values={values}
                    />
                </div>
            </Slide>
            <Slide direction={naviVisible.direction} in={naviVisible.fource} mountOnEnter unmountOnExit timeout={{ enter: 300, exit: 0 }}>
                <div>
                    <FourthStep 
                        prevStep={prevStep}
                        nextStep={nextStep}
                        handleChange={handleChange}
                        values={values}
                    />
                </div>
            </Slide>
        </React.Fragment>
    )
}

export default Navigation;
